import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { LogoFull } from "../components/Logo";
import { PasswordInput } from "../components/PasswordInput";
import { resetPassword, formatApiError } from "../lib/adminApi";


export default function AdminResetPage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (pw.length < 12) return setError("La nuova password deve avere almeno 12 caratteri.");
        if (pw !== pw2) return setError("Le due password non coincidono.");
        setBusy(true);
        try {
            await resetPassword(token, pw);
            setDone(true);
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#0B1F3A] px-4">
            <form onSubmit={submit} data-testid="admin-reset-form" className="w-full max-w-md rounded-3xl bg-white p-8 shadow-[0_32px_80px_-24px_rgba(0,0,0,0.5)] sm:p-10">
                <LogoFull />
                <div className="mt-8 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#E30613]">
                    <KeyRound className="h-3.5 w-3.5" /> Nuova password
                </div>
                {done ? (
                    <>
                        <p data-testid="admin-reset-done" className="mt-4 text-base font-semibold text-emerald-700">Password aggiornata correttamente.</p>
                        <Link to="/admin" className="mt-6 block rounded-full bg-[#E30613] px-6 py-3.5 text-center text-sm font-bold text-white">Vai all'accesso</Link>
                    </>
                ) : (
                    <>
                        {!token && <p role="alert" className="mt-4 text-sm font-semibold text-[#B91C1C]">Link non valido: manca il codice di reimpostazione.</p>}
                        <label className="mt-6 block text-xs font-bold uppercase tracking-wider text-[#4F5D70]">
                            Nuova password (min. 12 caratteri)
                            <PasswordInput value={pw} onChange={(e) => setPw(e.target.value)} testId="admin-reset-password" autoComplete="new-password" />
                        </label>
                        <label className="mt-4 block text-xs font-bold uppercase tracking-wider text-[#4F5D70]">
                            Conferma nuova password
                            <PasswordInput value={pw2} onChange={(e) => setPw2(e.target.value)} testId="admin-reset-confirm" autoComplete="new-password" />
                        </label>
                        {error && <p role="alert" data-testid="admin-reset-error" className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-[#B91C1C]">{error}</p>}
                        <button type="submit" disabled={busy || !token} data-testid="admin-reset-submit" className="mt-7 w-full rounded-full bg-[#E30613] px-6 py-3.5 text-sm font-bold text-white disabled:opacity-60">
                            {busy ? "Salvataggio…" : "Imposta nuova password"}
                        </button>
                    </>
                )}
            </form>
        </div>
    );
}
